/* tslint:disable */
/* eslint-disable */
/**
 * Propally Lp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AdjustTracker
 */
export interface AdjustTracker {
    /**
     * 
     * @type {number}
     * @memberof AdjustTracker
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdjustTracker
     */
    'user_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'first_tracker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'first_tracker_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'tracker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'tracker_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'request_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'remote_ip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'user_agent'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'adid'?: string | null;
    /**
     * 受信時の生パラメータ（JSON）
     * @type {object}
     * @memberof AdjustTracker
     */
    'raw_params'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface AdminAgentBorrowingRange
 */
export interface AdminAgentBorrowingRange {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    'annual_income_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    'annual_income_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    'multiplier'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminAgentMemo
 */
export interface AdminAgentMemo {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    'admin_user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    'agent_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface AdminAgentTargetConditionPayload
 */
export interface AdminAgentTargetConditionPayload {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'version'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'age_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'age_max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'annual_income_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'annual_income_max'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'work_experience_years'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'job_categories'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'job_industries'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentTargetConditionPayload
     */
    'free_note'?: string | null;
    /**
     * 
     * @type {Array<AdminAgentBorrowingRange>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'borrowing_ranges'?: Array<AdminAgentBorrowingRange>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'residence_prefectures'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminAgentTargetConditionPayload
     */
    'financial_asset_ids'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'investment_property_count_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    'investment_property_count_max'?: number | null;
}
/**
 * 
 * @export
 * @interface AdminUserMemo
 */
export interface AdminUserMemo {
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    'admin_user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    'company_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'password_confirmation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_authenticated_by_organizer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_admin'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'family_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'profile'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'last_accessed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'updated_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_enabled_notification_new_user'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_enabled_notification_new_property'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_need_user_notifications'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_displayed_in_recommend_feed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_displayed_in_active_feed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_displayed_in_compatibility_feed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_displayed_in_match_feed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_displayed_in_limited_property'?: boolean;
    /**
     * 対応可能種別一覧
     * @type {Array<AgentSupportedPropertyTypeEnum>}
     * @memberof Agent
     */
    'supported_property_types'?: Array<AgentSupportedPropertyTypeEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {AdminAgentMemo}
     * @memberof Agent
     */
    'admin_agent_memo'?: AdminAgentMemo;
    /**
     * エージェントのおすすめレベル
     * @type {number}
     * @memberof Agent
     */
    'recommendation_level'?: number | null;
    /**
     * 
     * @type {AgentCompatibilityRadar}
     * @memberof Agent
     */
    'compatibility_radar'?: AgentCompatibilityRadar | null;
    /**
     * 
     * @type {AgentPropallyComment}
     * @memberof Agent
     */
    'propally_comment'?: AgentPropallyComment | null;
    /**
     * 
     * @type {AgentCompatibilityProfile}
     * @memberof Agent
     */
    'agent_compatibility_profile'?: AgentCompatibilityProfile | null;
    /**
     * 
     * @type {Company}
     * @memberof Agent
     */
    'company'?: Company;
    /**
     * 
     * @type {AgentProfileImage}
     * @memberof Agent
     */
    'agent_profile_image'?: AgentProfileImage | null;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof Agent
     */
    'assessment_proposals'?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof Agent
     */
    'investment_proposals'?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof Agent
     */
    'proposal_matchings'?: Array<ProposalMatching>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof Agent
     */
    'contract_applications'?: Array<ContractApplication>;
    /**
     * 対象条件
     * @type {string}
     * @memberof Agent
     */
    'target_condition'?: string | null;
    /**
     * 
     * @type {AdminAgentTargetConditionPayload}
     * @memberof Agent
     */
    'target_condition_payload'?: AdminAgentTargetConditionPayload | null;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    'is_matched'?: boolean | null;
    /**
     * 
     * @type {AgentMetrics}
     * @memberof Agent
     */
    'metrics'?: AgentMetrics;
}
/**
 * 相性レーダー用営業可能エリア
 * @export
 * @enum {string}
 */

export const AgentCompatibilityAreaEnum = {
    関東: '関東',
    関西中京: '関西中京',
    九州: '九州',
    その他地方: 'その他地方',
    全国対応: '全国対応'
} as const;

export type AgentCompatibilityAreaEnum = typeof AgentCompatibilityAreaEnum[keyof typeof AgentCompatibilityAreaEnum];


/**
 * 相性レーダー用対応可資産帯プリセット
 * @export
 * @enum {string}
 */

export const AgentCompatibilityAssetPresetEnum = {
    _500万円以下: '〜500万円',
    _1000万円以下: '〜1,000万円',
    _3000万円以下: '〜3,000万円',
    _500万5000万円: '500万〜5,000万円',
    _1000万1億円: '1,000万〜1億円',
    _3000万円以上: '3,000万円〜',
    制限なし: '制限なし'
} as const;

export type AgentCompatibilityAssetPresetEnum = typeof AgentCompatibilityAssetPresetEnum[keyof typeof AgentCompatibilityAssetPresetEnum];


/**
 * 
 * @export
 * @interface AgentCompatibilityProfile
 */
export interface AgentCompatibilityProfile {
    /**
     * 
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    'id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    'agent_id'?: number | null;
    /**
     * 
     * @type {Array<AgentCompatibilityPropertyTypeEnum>}
     * @memberof AgentCompatibilityProfile
     */
    'supported_property_types'?: Array<AgentCompatibilityPropertyTypeEnum> | null;
    /**
     * 
     * @type {AgentCompatibilityPropertyTypeEnum}
     * @memberof AgentCompatibilityProfile
     */
    'primary_property_type'?: AgentCompatibilityPropertyTypeEnum | null;
    /**
     * 主力年収（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    'primary_annual_income'?: number | null;
    /**
     * 対応可年収レンジ下限（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    'supported_annual_income_min'?: number | null;
    /**
     * 対応可年収レンジ上限（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    'supported_annual_income_max'?: number | null;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof AgentCompatibilityProfile
     */
    'primary_asset_band'?: MoneyAmount | null;
    /**
     * 
     * @type {AgentCompatibilityAssetPresetEnum}
     * @memberof AgentCompatibilityProfile
     */
    'supported_asset_preset'?: AgentCompatibilityAssetPresetEnum | null;
    /**
     * 
     * @type {AgentCompatibilitySupportLevelEnum}
     * @memberof AgentCompatibilityProfile
     */
    'beginner_support_level'?: AgentCompatibilitySupportLevelEnum | null;
    /**
     * 
     * @type {AgentCompatibilitySupportLevelEnum}
     * @memberof AgentCompatibilityProfile
     */
    'experienced_support_level'?: AgentCompatibilitySupportLevelEnum | null;
    /**
     * 
     * @type {AgentCompatibilityAreaEnum}
     * @memberof AgentCompatibilityProfile
     */
    'primary_area'?: AgentCompatibilityAreaEnum | null;
    /**
     * 
     * @type {Array<AgentCompatibilityAreaEnum>}
     * @memberof AgentCompatibilityProfile
     */
    'supported_areas'?: Array<AgentCompatibilityAreaEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompatibilityProfile
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompatibilityProfile
     */
    'updated_at'?: string | null;
}


/**
 * 相性レーダー用物件種別
 * @export
 * @enum {string}
 */

export const AgentCompatibilityPropertyTypeEnum = {
    区分: '区分',
    一棟: '一棟',
    戸建: '戸建',
    海外: '海外',
    その他: 'その他'
} as const;

export type AgentCompatibilityPropertyTypeEnum = typeof AgentCompatibilityPropertyTypeEnum[keyof typeof AgentCompatibilityPropertyTypeEnum];


/**
 * 
 * @export
 * @interface AgentCompatibilityRadar
 */
export interface AgentCompatibilityRadar {
    /**
     * 5軸スコアの単純平均
     * @type {number}
     * @memberof AgentCompatibilityRadar
     */
    'total_score'?: number;
    /**
     * 
     * @type {AgentCompatibilityRadarScores}
     * @memberof AgentCompatibilityRadar
     */
    'scores'?: AgentCompatibilityRadarScores;
}
/**
 * 
 * @export
 * @interface AgentCompatibilityRadarScores
 */
export interface AgentCompatibilityRadarScores {
    /**
     * 得意物件種別一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    'property_type'?: number;
    /**
     * 得意年収一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    'annual_income'?: number;
    /**
     * 得意資産一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    'financial_asset'?: number;
    /**
     * 得意ステージ一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    'investment_stage'?: number;
    /**
     * 営業可能エリア一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    'area'?: number;
}
/**
 * 相性レーダー用ステージ対応度
 * @export
 * @enum {string}
 */

export const AgentCompatibilitySupportLevelEnum = {
    優先: '優先',
    普通: '普通',
    非優先: '非優先'
} as const;

export type AgentCompatibilitySupportLevelEnum = typeof AgentCompatibilitySupportLevelEnum[keyof typeof AgentCompatibilitySupportLevelEnum];


/**
 * エージェント一覧で表示する集計値（サーバ計算）。target_month 指定時は当月に限った値を返す。
 * @export
 * @interface AgentMetrics
 */
export interface AgentMetrics {
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'total_proposal_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'total_user_read_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'total_matching_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'total_contract_application_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'proposal_user_read_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'proposal_matching_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'contract_application_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_inflow_user_proposal_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_re_proposal_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_inflow_user_re_proposal_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_user_read_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_user_read_count_including_prev'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_matching_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_matching_count_including_prev'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_total_matching_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_contract_application_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_contract_application_count_including_prev'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_total_user_read_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_total_matching_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_match_rate_for_business_meeting'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_user_read_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_inflow_user_user_read_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_inflow_user_user_read_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_matching_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_inflow_user_matching_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_proposal_inflow_user_matching_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_contract_application_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_access_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_daily_average_access_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_contract_inflow_user_application_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    'target_month_contract_inflow_user_application_rate'?: number;
}
/**
 * 
 * @export
 * @interface AgentProfileImage
 */
export interface AgentProfileImage {
    /**
     * 
     * @type {number}
     * @memberof AgentProfileImage
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentProfileImage
     */
    'agent_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    'image_url'?: string | null;
}
/**
 * プロパリーからのコメント（User 向け API のみ設定される。未設定のエージェントは null）
 * @export
 * @interface AgentPropallyComment
 */
export interface AgentPropallyComment {
    /**
     * 
     * @type {string}
     * @memberof AgentPropallyComment
     */
    'comment': string;
}
/**
 * エージェントの対応可能種別
 * @export
 * @enum {string}
 */

export const AgentSupportedPropertyTypeEnum = {
    区分: '区分',
    一棟: '一棟',
    海外不動産: '海外不動産'
} as const;

export type AgentSupportedPropertyTypeEnum = typeof AgentSupportedPropertyTypeEnum[keyof typeof AgentSupportedPropertyTypeEnum];


/**
 * 
 * @export
 * @interface AiAssessmentErrorResponse
 */
export interface AiAssessmentErrorResponse {
    /**
     * API実行によるエラーメッセージ
     * @type {string}
     * @memberof AiAssessmentErrorResponse
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface AiAssessmentRequest
 */
export interface AiAssessmentRequest {
    /**
     * 最寄駅までの歩行時間（非負の整数）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'station_walk_minutes': number;
    /**
     * 面積（㎡）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'area': number;
    /**
     * 築年（正の整数）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'construction_year': number;
    /**
     * 建蔽率（%）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'building_coverage_ratio'?: number | null;
    /**
     * 容積率（%）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'floor_area_ratio'?: number | null;
    /**
     * 取引時期（\"YYYY年MM月\" 形式の文字列または null）
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'transaction_timing'?: string | null;
    /**
     * 都道府県名
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'prefecture': string;
    /**
     * 市区町村名
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'city_ward_town_village': string;
    /**
     * 地区名
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'district': string;
    /**
     * 最寄駅名
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'station_name': string;
    /**
     * 建物の構造
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'structure': string;
    /**
     * 都市計画（用途地域）
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'city_planning'?: string | null;
    /**
     * 間取り
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'layout'?: string | null;
    /**
     * 改装の有無（\"改装無\" または \"改装済み\" または null）
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'renovation'?: string | null;
    /**
     * 実売価格（百万円単位）
     * @type {number}
     * @memberof AiAssessmentRequest
     */
    'actual_sales_price': number;
    /**
     * 物件種別
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'property_type': string;
    /**
     * 姓
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'last_name': string;
    /**
     * 名
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'first_name': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'phone_number': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'email': string;
    /**
     * 備考（任意）
     * @type {string}
     * @memberof AiAssessmentRequest
     */
    'remarks'?: string;
}
/**
 * 
 * @export
 * @interface AiAssessmentResponse
 */
export interface AiAssessmentResponse {
    /**
     * AIによって算出された適正な査定金額（円）
     * @type {number}
     * @memberof AiAssessmentResponse
     */
    'estimated_price': number;
    /**
     * 推定値のスコア
     * @type {number}
     * @memberof AiAssessmentResponse
     */
    'score': number;
    /**
     * 推定の誤差範囲（円）
     * @type {number}
     * @memberof AiAssessmentResponse
     */
    'error_margin': number;
    /**
     * モデルの標準偏差（円）
     * @type {number}
     * @memberof AiAssessmentResponse
     */
    'standard_deviation': number;
}
/**
 * 
 * @export
 * @interface AssessmentProposal
 */
export interface AssessmentProposal {
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'agent_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'property_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'proposal_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'proposal_content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    'is_user_read'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    'is_user_approved'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    'trade_type'?: number | null;
    /**
     * status=scheduled の場合は予約送信予定日時、status=sent の場合は実送信日時
     * @type {string}
     * @memberof AssessmentProposal
     */
    'proposal_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'user_read_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'user_approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'user_registered_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'short_appeal_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {ProposalDeliveryStatus}
     * @memberof AssessmentProposal
     */
    'status'?: ProposalDeliveryStatus;
    /**
     * 送信失敗理由。例 daily_offer_limit
     * @type {string}
     * @memberof AssessmentProposal
     */
    'failure_reason'?: string | null;
    /**
     * 
     * @type {Agent}
     * @memberof AssessmentProposal
     */
    'agent'?: Agent;
    /**
     * 
     * @type {User}
     * @memberof AssessmentProposal
     */
    'user'?: User;
    /**
     * 
     * @type {Property}
     * @memberof AssessmentProposal
     */
    'property'?: Property;
    /**
     * 
     * @type {Array<AssessmentProposalAttachmentFile>}
     * @memberof AssessmentProposal
     */
    'assessment_proposal_attachment_files'?: Array<AssessmentProposalAttachmentFile>;
    /**
     * 
     * @type {ProposalStatusEnum}
     * @memberof AssessmentProposal
     */
    'proposal_status'?: ProposalStatusEnum | null;
    /**
     * 本提案がマッチしているかどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    'is_matched'?: boolean | null;
    /**
     * ユーザーが本提案をマッチ（承認）可能かどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    'is_matchable'?: boolean | null;
    /**
     * 全提案、手動ユーザ提案含め、ユーザとエージェントでのマッチが存在するかどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    'has_matched'?: boolean | null;
}


/**
 * 
 * @export
 * @interface AssessmentProposalAttachmentFile
 */
export interface AssessmentProposalAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposalAttachmentFile
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposalAttachmentFile
     */
    'assessment_proposal_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    'file_url'?: string | null;
}
/**
 * 
 * @export
 * @interface BuildingDetail
 */
export interface BuildingDetail {
    /**
     * 管理会社委託費（建物＋賃貸管理含む）
     * @type {number}
     * @memberof BuildingDetail
     */
    'management_company_commission'?: number | null;
    /**
     * 共用部水道光熱費
     * @type {number}
     * @memberof BuildingDetail
     */
    'shared_utility_expenses'?: number | null;
    /**
     * その他経費
     * @type {number}
     * @memberof BuildingDetail
     */
    'misc_building_cost'?: number | null;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'home_page_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'short_appeal_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'achievements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'strengths_of_properties_for_sale_and_purchase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'strengths_of_partner_financial_institutions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'strengths_of_properties_for_management'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'appeal_point'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    'updated_at'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Company
     */
    'company_agent_search_tag_ids'?: Array<number>;
    /**
     * 
     * @type {CompanyLogoImage}
     * @memberof Company
     */
    'company_logo_image'?: CompanyLogoImage | null;
    /**
     * 
     * @type {Array<SalesAchievements>}
     * @memberof Company
     */
    'sales_achievements'?: Array<SalesAchievements>;
    /**
     * 
     * @type {Array<LimitedProperties>}
     * @memberof Company
     */
    'limited_properties'?: Array<LimitedProperties>;
}
/**
 * 
 * @export
 * @interface CompanyLogoImage
 */
export interface CompanyLogoImage {
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoImage
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoImage
     */
    'company_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    'image_url'?: string | null;
}
/**
 * 検討時期
 * @export
 * @enum {string}
 */

export const ConsiderationPeriodEnum = {
    一ヶ月以内: '一ヶ月以内',
    半年以内: '半年以内',
    一年以内: '一年以内',
    それ以上: 'それ以上'
} as const;

export type ConsiderationPeriodEnum = typeof ConsiderationPeriodEnum[keyof typeof ConsiderationPeriodEnum];


/**
 * 
 * @export
 * @interface ContractApplication
 */
export interface ContractApplication {
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    'proposal_matching_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    'agent_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'application_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    'contract_price'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'contract_property_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'contract_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    'user_registered_at'?: string | null;
    /**
     * 
     * @type {Agent}
     * @memberof ContractApplication
     */
    'agent'?: Agent;
    /**
     * 
     * @type {User}
     * @memberof ContractApplication
     */
    'user'?: User;
    /**
     * 
     * @type {Array<ContractApplicationAttachmentFile>}
     * @memberof ContractApplication
     */
    'contract_application_attachment_files'?: Array<ContractApplicationAttachmentFile>;
}
/**
 * 
 * @export
 * @interface ContractApplicationAttachmentFile
 */
export interface ContractApplicationAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof ContractApplicationAttachmentFile
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplicationAttachmentFile
     */
    'contract_application_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    'attachment_file_url'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DegreeOfConsiderationEnum = {
    Considering: 'Considering',
    NotConsidered: 'NotConsidered'
} as const;

export type DegreeOfConsiderationEnum = typeof DegreeOfConsiderationEnum[keyof typeof DegreeOfConsiderationEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DeviceTypeEnum = {
    Ios: 'ios',
    Android: 'android',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type DeviceTypeEnum = typeof DeviceTypeEnum[keyof typeof DeviceTypeEnum];


/**
 * HowMa(外部API)_建物エリア情報
 * @export
 * @interface HowMaArea
 */
export interface HowMaArea {
    /**
     * 住所テキスト(丁目）
     * @type {string}
     * @memberof HowMaArea
     */
    'name': string;
}
/**
 * HowMa(外部API)_建物情報
 * @export
 * @interface HowMaBuilding
 */
export interface HowMaBuilding {
    /**
     * マンションID(コラビット)
     * @type {number}
     * @memberof HowMaBuilding
     */
    'id': number;
    /**
     * マンション名称
     * @type {string}
     * @memberof HowMaBuilding
     */
    'name': string;
    /**
     * 竣工年
     * @type {number}
     * @memberof HowMaBuilding
     */
    'built_at_year': number;
    /**
     * 総階数
     * @type {number}
     * @memberof HowMaBuilding
     */
    'floor_number'?: number;
    /**
     * 
     * @type {HowMaStation}
     * @memberof HowMaBuilding
     */
    'station'?: HowMaStation | null;
    /**
     * 
     * @type {HowMaArea}
     * @memberof HowMaBuilding
     */
    'area': HowMaArea;
}
/**
 * HowMa(外部API)_建物検索APIレスポンスの型
 * @export
 * @interface HowMaBuildingsResponse
 */
export interface HowMaBuildingsResponse {
    /**
     * 建物候補一覧
     * @type {Array<HowMaBuilding>}
     * @memberof HowMaBuildingsResponse
     */
    'buildings': Array<HowMaBuilding>;
    /**
     * 検索結果の合計件数
     * @type {number}
     * @memberof HowMaBuildingsResponse
     */
    'total_count': number;
}
/**
 * HowMa(外部API)_建物検索APIリクエストの型
 * @export
 * @interface HowMaBuildingsSearchRequest
 */
export interface HowMaBuildingsSearchRequest {
    /**
     * マンション名テキスト
     * @type {string}
     * @memberof HowMaBuildingsSearchRequest
     */
    'text': string;
    /**
     * ソート設定(任意)
     * @type {string}
     * @memberof HowMaBuildingsSearchRequest
     */
    'order'?: string;
    /**
     * ソート設定(昇順フラグ)(任意)
     * @type {boolean}
     * @memberof HowMaBuildingsSearchRequest
     */
    'ascending'?: boolean;
    /**
     * 建物候補の件数(任意)
     * @type {number}
     * @memberof HowMaBuildingsSearchRequest
     */
    'limit'?: number;
    /**
     * 一覧のページ番号(任意)
     * @type {number}
     * @memberof HowMaBuildingsSearchRequest
     */
    'page'?: number;
}
/**
 * HowMa(外部API)_部屋情報
 * @export
 * @interface HowMaRoom
 */
export interface HowMaRoom {
    /**
     * 部屋番号
     * @type {string}
     * @memberof HowMaRoom
     */
    'name': string;
    /**
     * 間取り(半角文字列)
     * @type {string}
     * @memberof HowMaRoom
     */
    'floor_plan': string;
    /**
     * 専有面積(㎡、小数点2桁)
     * @type {number}
     * @memberof HowMaRoom
     */
    'm2': number;
    /**
     * 所在階
     * @type {number}
     * @memberof HowMaRoom
     */
    'floor_number': number;
}
/**
 * HowMa(外部API)_建物詳細取得APIレスポンスの型
 * @export
 * @interface HowMaRoomsSearchResponse
 */
export interface HowMaRoomsSearchResponse {
    /**
     * 
     * @type {HowMaBuilding}
     * @memberof HowMaRoomsSearchResponse
     */
    'building': HowMaBuilding;
    /**
     * 部屋情報一覧
     * @type {Array<HowMaRoom>}
     * @memberof HowMaRoomsSearchResponse
     */
    'rooms': Array<HowMaRoom>;
    /**
     * 部屋の合計件数
     * @type {number}
     * @memberof HowMaRoomsSearchResponse
     */
    'total_count': number;
}
/**
 * HowMa(外部API)_駅情報
 * @export
 * @interface HowMaStation
 */
export interface HowMaStation {
    /**
     * 最寄駅名称
     * @type {string}
     * @memberof HowMaStation
     */
    'name': string;
    /**
     * 駅コード(コラビット) 整数7桁 ※新幹線は6桁
     * @type {number}
     * @memberof HowMaStation
     */
    'cd': number;
    /**
     * 路線コード(コラビット) 整数5桁 ※新幹線は4桁
     * @type {number}
     * @memberof HowMaStation
     */
    'line_cd': number;
}
/**
 * 
 * @export
 * @interface IdName
 */
export interface IdName {
    /**
     * 
     * @type {number}
     * @memberof IdName
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IdName
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'property_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'image_url'?: string | null;
}
/**
 * 
 * @export
 * @interface InvestmentProposal
 */
export interface InvestmentProposal {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    'agent_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'proposal_content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    'is_user_read'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    'is_user_approved'?: boolean | null;
    /**
     * status=scheduled の場合は予約送信予定日時、status=sent の場合は実送信日時
     * @type {string}
     * @memberof InvestmentProposal
     */
    'proposal_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'user_read_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'user_approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'user_registered_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'short_appeal_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {ProposalDeliveryStatus}
     * @memberof InvestmentProposal
     */
    'status'?: ProposalDeliveryStatus;
    /**
     * 送信失敗理由。例 daily_offer_limit
     * @type {string}
     * @memberof InvestmentProposal
     */
    'failure_reason'?: string | null;
    /**
     * 第一希望日
     * @type {string}
     * @memberof InvestmentProposal
     */
    'first_preferred_contact_date'?: string | null;
    /**
     * 第一希望時間帯
     * @type {string}
     * @memberof InvestmentProposal
     */
    'first_preferred_contact_time_slot'?: InvestmentProposalFirstPreferredContactTimeSlotEnum | null;
    /**
     * 第二希望日
     * @type {string}
     * @memberof InvestmentProposal
     */
    'second_preferred_contact_date'?: string | null;
    /**
     * 第二希望時間帯
     * @type {string}
     * @memberof InvestmentProposal
     */
    'second_preferred_contact_time_slot'?: InvestmentProposalSecondPreferredContactTimeSlotEnum | null;
    /**
     * 
     * @type {Agent}
     * @memberof InvestmentProposal
     */
    'agent'?: Agent;
    /**
     * 
     * @type {User}
     * @memberof InvestmentProposal
     */
    'user'?: User;
    /**
     * 
     * @type {Array<InvestmentProposalAttachmentFile>}
     * @memberof InvestmentProposal
     */
    'investment_proposal_attachment_files'?: Array<InvestmentProposalAttachmentFile>;
    /**
     * 
     * @type {ProposalStatusEnum}
     * @memberof InvestmentProposal
     */
    'proposal_status'?: ProposalStatusEnum | null;
    /**
     * 本提案がマッチしているかどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    'is_matched'?: boolean | null;
    /**
     * ユーザーが本提案をマッチ（承認）可能かどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    'is_matchable'?: boolean | null;
    /**
     * 全提案、手動ユーザ提案含め、ユーザとエージェントでのマッチが存在するかどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    'has_matched'?: boolean | null;
    /**
     * 必要に応じて、ユーザーと該当エージェント間の提案履歴を返す
     * @type {Array<InvestmentProposalHistory>}
     * @memberof InvestmentProposal
     */
    'history_investment_proposals'?: Array<InvestmentProposalHistory> | null;
    /**
     * 
     * @type {OfferScore}
     * @memberof InvestmentProposal
     */
    'offer_score'?: OfferScore | null;
}

export const InvestmentProposalFirstPreferredContactTimeSlotEnum = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening'
} as const;

export type InvestmentProposalFirstPreferredContactTimeSlotEnum = typeof InvestmentProposalFirstPreferredContactTimeSlotEnum[keyof typeof InvestmentProposalFirstPreferredContactTimeSlotEnum];
export const InvestmentProposalSecondPreferredContactTimeSlotEnum = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening'
} as const;

export type InvestmentProposalSecondPreferredContactTimeSlotEnum = typeof InvestmentProposalSecondPreferredContactTimeSlotEnum[keyof typeof InvestmentProposalSecondPreferredContactTimeSlotEnum];

/**
 * 
 * @export
 * @interface InvestmentProposalAttachmentFile
 */
export interface InvestmentProposalAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalAttachmentFile
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalAttachmentFile
     */
    'investment_proposal_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    'object_storage_path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    'file_url'?: string | null;
}
/**
 * 
 * @export
 * @interface InvestmentProposalHistory
 */
export interface InvestmentProposalHistory {
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    'short_appeal_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    'proposal_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    'proposal_content'?: string;
}
/**
 * 職業
 * @export
 * @enum {string}
 */

export const JobCategory = {
    会社員上場: '会社員（上場）',
    会社員非上場: '会社員（非上場）',
    会社員外資系企業: '会社員（外資系企業）',
    会社役員: '会社役員',
    公務員: '公務員',
    士業: '士業',
    医師歯科医師: '医師・歯科医師',
    薬剤師看護師: '薬剤師・看護師',
    自営業: '自営業',
    その他: 'その他',
    入力なし: '入力なし'
} as const;

export type JobCategory = typeof JobCategory[keyof typeof JobCategory];


/**
 * 業界
 * @export
 * @enum {string}
 */

export const JobIndustry = {
    It通信系: 'IT・通信系',
    サービス系: 'サービス系',
    メーカー系電気機械: 'メーカー系(電気・機械)',
    メーカー系素材医薬品他: 'メーカー系(素材・医薬品他)',
    メーカー系自動車輸送用機器: 'メーカー系(自動車・輸送用機器)',
    専門コンサル系: '専門コンサル系',
    商社系電気機械系: '商社系(電気・機械系)',
    商社系総合素材医薬品他: '商社系(総合・素材・医薬品他)',
    金融系: '金融系',
    不動産系: '不動産系',
    建設系: '建設系',
    マスコミ系: 'マスコミ系',
    流通小売系: '流通・小売系',
    インターネットWeb業界: 'インターネット・Web業界',
    ゲーム業界: 'ゲーム業界',
    広告マーケティング系: '広告・マーケティング系',
    教育学校系: '教育・学校系',
    医療福祉系: '医療・福祉系',
    エネルギー環境系: 'エネルギー・環境系',
    官公庁公共サービス系: '官公庁・公共サービス系',
    運輸物流倉庫系: '運輸・物流・倉庫系',
    飲食フード系: '飲食・フード系',
    その他: 'その他'
} as const;

export type JobIndustry = typeof JobIndustry[keyof typeof JobIndustry];


/**
 * 
 * @export
 * @interface LeaseContract
 */
export interface LeaseContract {
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'property_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'monthly_fee': number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'monthly_management_fee': number;
    /**
     * その他収入（月額）
     * @type {number}
     * @memberof LeaseContract
     */
    'other_monthly_income'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'starts_at': string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'ends_at': string;
    /**
     * 新規賃貸契約手数料 (賃料のN倍)
     * @type {number}
     * @memberof LeaseContract
     */
    'outsourcing_fee_rate_of_new_lease_contract'?: number | null;
    /**
     * 賃貸契約更新手数料（賃料のN倍)
     * @type {number}
     * @memberof LeaseContract
     */
    'outsourcing_fee_rate_of_updating_lease_contract'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'key_money'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    'security_deposit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'type_of_the_income_of_the_beginning_of_contract'?: LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum | null;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    'discarded_at'?: string | null;
}

export const LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum = {
    KeyMoney: 'KeyMoney',
    SecurityDeposit: 'SecurityDeposit'
} as const;

export type LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum = typeof LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum[keyof typeof LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum];

/**
 * 
 * @export
 * @interface LimitedProperties
 */
export interface LimitedProperties {
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    'agent_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    'property_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    'property_area'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    'property_price'?: number;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    'property_monthly_rent'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    'property_nearest_station'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    'property_building_age'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    'file_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    'object_storage_path'?: string | null;
}
/**
 * 
 * @export
 * @interface LpV1SendPhoneNumberAuthCodesPost201Response
 */
export interface LpV1SendPhoneNumberAuthCodesPost201Response {
    /**
     * 
     * @type {string}
     * @memberof LpV1SendPhoneNumberAuthCodesPost201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface LpV1SendPhoneNumberAuthCodesPostRequest
 */
export interface LpV1SendPhoneNumberAuthCodesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof LpV1SendPhoneNumberAuthCodesPostRequest
     */
    'phone_number'?: string;
}
/**
 * マスタテーブル全般用の汎用schema型
 * @export
 * @interface Master
 */
export interface Master {
    /**
     * 
     * @type {number}
     * @memberof Master
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof Master
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    'updated_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Master
     */
    'is_active'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MatchingType = {
    投資: '投資',
    査定: '査定',
    手動: '手動',
    ユーザ: 'ユーザ'
} as const;

export type MatchingType = typeof MatchingType[keyof typeof MatchingType];


/**
 * 金融資産
 * @export
 * @enum {string}
 */

export const MoneyAmount = {
    未選択: '未選択',
    なし: 'なし',
    _500万円: '〜500万円',
    _5001000万円: '500〜1,000万円',
    _10002000万円: '1,000〜2,000万円',
    _20003000万円: '2,000〜3,000万円',
    _30005000万円: '3,000〜5,000万円',
    _5000万円1億円: '5,000万円〜1億円',
    _12億円: '1〜2億円',
    _23億円: '2〜3億円',
    _35億円: '3〜5億円',
    _510億円: '5〜10億円',
    _10億円: '10億円〜'
} as const;

export type MoneyAmount = typeof MoneyAmount[keyof typeof MoneyAmount];


/**
 * 
 * @export
 * @interface MonthlyCashflowResult
 */
export interface MonthlyCashflowResult {
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'property_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'month'?: string;
    /**
     * 賃料収入
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'rent_income'?: number | null;
    /**
     * 管理費収入
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'management_fee_income'?: number | null;
    /**
     * 通信費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'communication_cost'?: number | null;
    /**
     * 賃貸管理費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'management_cost'?: number | null;
    /**
     * 物件管理費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'building_management_cost'?: number | null;
    /**
     * 修繕積立金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'repair_fund_cost'?: number | null;
    /**
     * その他経費（毎月発生するもの)
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'misc_cost'?: number | null;
    /**
     * ローン支払い（金利分）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'loan_interest'?: number | null;
    /**
     * ローン利率（当月からの）（％）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'loan_interest_rate_percentage'?: number | null;
    /**
     * ローン支払い（元金分）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'loan_principal'?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'loan_prepayment'?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済方式） * ReduceLoanAmount: 返済額軽減型 * ReduceLoanPaymentPeriod: 期間短縮型 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'loan_prepayment_method'?: MonthlyCashflowResultLoanPrepaymentMethodEnum | null;
    /**
     * 礼金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'key_money'?: number | null;
    /**
     * 更新料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'security_deposit'?: number | null;
    /**
     * 固定資産税
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'property_tax'?: number | null;
    /**
     * 火災保険料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'fire_insurance_cost'?: number | null;
    /**
     * 火災保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'fire_insurance_holding_period'?: number | null;
    /**
     * 地震保険料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'earthquake_insurance_cost'?: number | null;
    /**
     * 地震保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'earthquake_insurance_holding_period'?: number | null;
    /**
     * 大規模修繕費用
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'large_scale_repair_fund_cost'?: number | null;
    /**
     * 消耗品費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'supplies_cost'?: number | null;
    /**
     * その他一過性の費用
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'misc_onetime_cost'?: number | null;
    /**
     * その他一過性の費用(内容)
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'misc_onetime_cost_contents'?: string | null;
    /**
     * 不動産所得にかかる税金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'tax_on_real_estates'?: number | null;
    /**
     * 新規賃貸契約手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'outsourcing_fee_of_new_lease_contract'?: number | null;
    /**
     * 賃貸契約更新手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    'outsourcing_fee_of_updating_lease_contract'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    'discarded_at'?: string | null;
}

export const MonthlyCashflowResultLoanPrepaymentMethodEnum = {
    ReduceLoanAmount: 'ReduceLoanAmount',
    ReduceLoanPaymentPeriod: 'ReduceLoanPaymentPeriod'
} as const;

export type MonthlyCashflowResultLoanPrepaymentMethodEnum = typeof MonthlyCashflowResultLoanPrepaymentMethodEnum[keyof typeof MonthlyCashflowResultLoanPrepaymentMethodEnum];

/**
 * 
 * @export
 * @interface OfferScore
 */
export interface OfferScore {
    /**
     * 
     * @type {number}
     * @memberof OfferScore
     */
    'id'?: number;
    /**
     * ユーザーが提案を閲覧する推定確率
     * @type {number}
     * @memberof OfferScore
     */
    'read_probability'?: number;
    /**
     * ユーザーが提案を承認・マッチする推定確率
     * @type {number}
     * @memberof OfferScore
     */
    'match_probability'?: number;
    /**
     * 表示や並び替えに利用する総合スコア
     * @type {number}
     * @memberof OfferScore
     */
    'score'?: number;
    /**
     * スコア算出に利用したモデルバージョン
     * @type {string}
     * @memberof OfferScore
     */
    'model_version'?: string;
    /**
     * スコア算出日時
     * @type {string}
     * @memberof OfferScore
     */
    'scored_at'?: string;
    /**
     * スコア算出時に利用した特徴量
     * @type {object}
     * @memberof OfferScore
     */
    'features'?: object | null;
}
/**
 * 今までの面談回数
 * @export
 * @enum {string}
 */

export const PastMeetingCountEnum = {
    _1回: '1回',
    _2回: '2回',
    _3回: '3回',
    それ以上: 'それ以上'
} as const;

export type PastMeetingCountEnum = typeof PastMeetingCountEnum[keyof typeof PastMeetingCountEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const Period = {
    _6ヶ月未満: '6ヶ月未満',
    _6ヶ月以上1年未満: '6ヶ月以上1年未満',
    _1年以上3年未満: '1年以上3年未満',
    _3年以上: '3年以上'
} as const;

export type Period = typeof Period[keyof typeof Period];


/**
 * 
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    'user_id'?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof Property
     */
    'score'?: number | null;
    /**
     * 
     * @type {PropertyType}
     * @memberof Property
     */
    'property_type'?: PropertyType;
    /**
     * 
     * @type {PropertyCategory}
     * @memberof Property
     */
    'property_category'?: PropertyCategory;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'prefecture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'town'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'block'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'railway'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'station'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    'walk'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'bought_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'built_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'structure'?: PropertyStructureEnum;
    /**
     * 購入価格 (下記priceof_* の合計)
     * @type {number}
     * @memberof Property
     */
    'total_price_of_property'?: number;
    /**
     * うち建物
     * @type {number}
     * @memberof Property
     */
    'priceof_building'?: number | null;
    /**
     * うち設備
     * @type {number}
     * @memberof Property
     */
    'priceof_facilities'?: number | null;
    /**
     * うち土地
     * @type {number}
     * @memberof Property
     */
    'priceof_land'?: number | null;
    /**
     * うち消費税
     * @type {any}
     * @memberof Property
     */
    'priceof_tax'?: any | null;
    /**
     * ローン総額
     * @type {number}
     * @memberof Property
     */
    'loan_amount'?: number;
    /**
     * 支払い開始月
     * @type {string}
     * @memberof Property
     */
    'payment_starts_at'?: string;
    /**
     * 支払い期間（年）
     * @type {number}
     * @memberof Property
     */
    'payment_period'?: number;
    /**
     * 賃貸管理会社
     * @type {string}
     * @memberof Property
     */
    'rental_management_company'?: string | null;
    /**
     * 管理形態
     * @type {string}
     * @memberof Property
     */
    'management_type'?: PropertyManagementTypeEnum;
    /**
     * 売却状況
     * @type {string}
     * @memberof Property
     */
    'sales_status'?: PropertySalesStatusEnum;
    /**
     * 不動産取得税
     * @type {number}
     * @memberof Property
     */
    'property_acquisition_tax'?: number | null;
    /**
     * 不動産取得税の支払い月
     * @type {string}
     * @memberof Property
     */
    'property_acquisition_tax_payment_month'?: string | null;
    /**
     * 購入時諸費用
     * @type {number}
     * @memberof Property
     */
    'misc_expences_at_bought'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    'discarded_at'?: string | null;
    /**
     * 希望売却価格（あれば）
     * @type {number}
     * @memberof Property
     */
    'asking_price'?: number | null;
    /**
     * 
     * @type {UnitDetail}
     * @memberof Property
     */
    'unit_detail'?: UnitDetail;
    /**
     * 
     * @type {BuildingDetail}
     * @memberof Property
     */
    'building_detail'?: BuildingDetail;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Property
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {Array<LeaseContract>}
     * @memberof Property
     */
    'lease_contracts'?: Array<LeaseContract>;
    /**
     * 
     * @type {Array<MonthlyCashflowResult>}
     * @memberof Property
     */
    'monthly_cashflow_results'?: Array<MonthlyCashflowResult>;
    /**
     * 
     * @type {User}
     * @memberof Property
     */
    'user'?: User;
    /**
     * 
     * @type {Image}
     * @memberof Property
     */
    'image'?: Image;
    /**
     * 
     * @type {LeaseContract}
     * @memberof Property
     */
    'lease_contract_latest'?: LeaseContract;
    /**
     * 
     * @type {LeaseContract}
     * @memberof Property
     */
    'lease_contract_current'?: LeaseContract;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof Property
     */
    'monthly_cashflow_result_latest'?: MonthlyCashflowResult;
    /**
     * 新着物件かどうか
     * @type {boolean}
     * @memberof Property
     */
    'is_new_label'?: boolean;
    /**
     * AIおまかせ入力で作成した物件についてのお知らせが必要かどうか
     * @type {boolean}
     * @memberof Property
     */
    'is_need_ai_create_notification'?: boolean | null;
    /**
     * AIおまかせ入力で作成した物件のお知らせを閉じたかどうか
     * @type {boolean}
     * @memberof Property
     */
    'is_ai_create_notification_dismissed'?: boolean;
    /**
     * お気に入り登録済みかどうか
     * @type {boolean}
     * @memberof Property
     */
    'is_favorite'?: boolean;
    /**
     * ローン残債
     * @type {number}
     * @memberof Property
     */
    'remain_loan_amount'?: number | null;
    /**
     * 所有ユーザーの売却希望タグ有無
     * @type {boolean}
     * @memberof Property
     */
    'has_sell_tag'?: boolean;
    /**
     * 月額家賃収入 + 月額管理費収入
     * @type {number}
     * @memberof Property
     */
    'monthly_total_fee'?: number | null;
    /**
     * 月額建物管理費 + 月額修繕積立金
     * @type {number}
     * @memberof Property
     */
    'monthly_building_total_cost'?: number | null;
}

export const PropertyStructureEnum = {
    未選択: '未選択',
    Src造鉄骨鉄筋コンクリート造: 'SRC造(鉄骨鉄筋コンクリート造)',
    Rc造鉄筋コンクリート造: 'RC造(鉄筋コンクリート造)',
    S造重量鉄骨造: 'S造(重量鉄骨造)',
    木造: '木造'
} as const;

export type PropertyStructureEnum = typeof PropertyStructureEnum[keyof typeof PropertyStructureEnum];
export const PropertyManagementTypeEnum = {
    NotSelected: 'NotSelected',
    Outsourcing: 'Outsourcing',
    MoneyCollectionAgency: 'MoneyCollectionAgency',
    SelfManagement: 'SelfManagement',
    Subleasing: 'Subleasing'
} as const;

export type PropertyManagementTypeEnum = typeof PropertyManagementTypeEnum[keyof typeof PropertyManagementTypeEnum];
export const PropertySalesStatusEnum = {
    未選択: '未選択',
    売りに出していない: '売りに出していない',
    売却希望: '売却希望',
    一般媒介契約締結済み: '一般媒介契約締結済み',
    専任媒介契約締結済み: '専任媒介契約締結済み',
    専属専任媒介締結済み: '専属専任媒介締結済み'
} as const;

export type PropertySalesStatusEnum = typeof PropertySalesStatusEnum[keyof typeof PropertySalesStatusEnum];

/**
 * 物件構造種別 
 * @export
 * @enum {string}
 */

export const PropertyCategory = {
    区分マンション: '区分マンション',
    一棟物件: '一棟物件',
    戸建: '戸建'
} as const;

export type PropertyCategory = typeof PropertyCategory[keyof typeof PropertyCategory];


/**
 * 物件種別 0: 保有物件 1: 検討中物件 2: 提案物件 3: サンプル保有物件 
 * @export
 * @enum {number}
 */

export const PropertyType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type PropertyType = typeof PropertyType[keyof typeof PropertyType];


/**
 * オファー送信状態。scheduled=予約中、sent=送信済み、failed=送信失敗、canceled=キャンセル済み
 * @export
 * @enum {string}
 */

export const ProposalDeliveryStatus = {
    Scheduled: 'scheduled',
    Sent: 'sent',
    Failed: 'failed',
    Canceled: 'canceled'
} as const;

export type ProposalDeliveryStatus = typeof ProposalDeliveryStatus[keyof typeof ProposalDeliveryStatus];


/**
 * 
 * @export
 * @interface ProposalMatching
 */
export interface ProposalMatching {
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    'is_invalid'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'agent_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'user_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'assessment_proposal_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'investment_proposal_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    'is_manual_match'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    'is_agent_read'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    'user_registered_at'?: string | null;
    /**
     * 第一希望日
     * @type {string}
     * @memberof ProposalMatching
     */
    'first_preferred_contact_date'?: string | null;
    /**
     * 第一希望時間帯
     * @type {string}
     * @memberof ProposalMatching
     */
    'first_preferred_contact_time_slot'?: ProposalMatchingFirstPreferredContactTimeSlotEnum | null;
    /**
     * 第二希望日
     * @type {string}
     * @memberof ProposalMatching
     */
    'second_preferred_contact_date'?: string | null;
    /**
     * 第二希望時間帯
     * @type {string}
     * @memberof ProposalMatching
     */
    'second_preferred_contact_time_slot'?: ProposalMatchingSecondPreferredContactTimeSlotEnum | null;
    /**
     * 
     * @type {Agent}
     * @memberof ProposalMatching
     */
    'agent'?: Agent;
    /**
     * 
     * @type {User}
     * @memberof ProposalMatching
     */
    'user'?: User;
    /**
     * 
     * @type {InvestmentProposal}
     * @memberof ProposalMatching
     */
    'investment_proposal'?: InvestmentProposal;
    /**
     * 
     * @type {AssessmentProposal}
     * @memberof ProposalMatching
     */
    'assessment_proposal'?: AssessmentProposal;
    /**
     * 
     * @type {UserProposal}
     * @memberof ProposalMatching
     */
    'user_proposal'?: UserProposal;
    /**
     * 対象ユーザの成約申請済みが1件以上あるかどうか
     * @type {boolean}
     * @memberof ProposalMatching
     */
    'is_contract_applied'?: boolean;
    /**
     * 
     * @type {MatchingType}
     * @memberof ProposalMatching
     */
    'matching_type'?: MatchingType;
    /**
     * ユーザーマッチ時の内訳（プロ検索 or 限定物件）
     * @type {string}
     * @memberof ProposalMatching
     */
    'user_matching_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    'matching_counts'?: number;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof ProposalMatching
     */
    'matched_count_sum'?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    'matched_count_user'?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    'matched_count_investment'?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    'matched_count_assessment'?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    'matched_count_manual'?: number | null;
    /**
     * 
     * @type {SalesNoteProspectLankEnum}
     * @memberof ProposalMatching
     */
    'prospect_lank'?: SalesNoteProspectLankEnum | null;
    /**
     * 
     * @type {SalesNoteStatusEnum}
     * @memberof ProposalMatching
     */
    'status'?: SalesNoteStatusEnum | null;
    /**
     * 
     * @type {SalesNoteCompleteReasonEnum}
     * @memberof ProposalMatching
     */
    'complete_reason'?: SalesNoteCompleteReasonEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    'progress'?: string | null;
    /**
     * 進捗メモの最終更新日時（楽観的排他制御用）
     * @type {string}
     * @memberof ProposalMatching
     */
    'sales_note_updated_at'?: string | null;
    /**
     * 
     * @type {UserOfferSourceCategoryEnum}
     * @memberof ProposalMatching
     */
    'user_offer_source_category'?: UserOfferSourceCategoryEnum | null;
    /**
     * 
     * @type {UserOfferSourceAnalysisItemSourceEnum}
     * @memberof ProposalMatching
     */
    'user_offer_source'?: UserOfferSourceAnalysisItemSourceEnum;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof ProposalMatching
     */
    'learning_completed_count'?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof ProposalMatching
     */
    'learning_progress_rate'?: number | null;
    /**
     * エージェントの対象条件に合致しているか
     * @type {boolean}
     * @memberof ProposalMatching
     */
    'is_target'?: boolean;
}

export const ProposalMatchingFirstPreferredContactTimeSlotEnum = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening'
} as const;

export type ProposalMatchingFirstPreferredContactTimeSlotEnum = typeof ProposalMatchingFirstPreferredContactTimeSlotEnum[keyof typeof ProposalMatchingFirstPreferredContactTimeSlotEnum];
export const ProposalMatchingSecondPreferredContactTimeSlotEnum = {
    Morning: 'morning',
    Afternoon: 'afternoon',
    Evening: 'evening'
} as const;

export type ProposalMatchingSecondPreferredContactTimeSlotEnum = typeof ProposalMatchingSecondPreferredContactTimeSlotEnum[keyof typeof ProposalMatchingSecondPreferredContactTimeSlotEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ProposalStatusEnum = {
    提案済み: '提案済み',
    取り消し済み: '取り消し済み',
    マッチ: 'マッチ',
    成約済み: '成約済み',
    予約中: '予約中',
    送信失敗: '送信失敗',
    予約取消: '予約取消'
} as const;

export type ProposalStatusEnum = typeof ProposalStatusEnum[keyof typeof ProposalStatusEnum];


/**
 * 紹介キャンペーンID（referral_ref） - regular: 通常特典（デフォルト値） - email_gift: メール特典 
 * @export
 * @enum {string}
 */

export const ReferralRefEnum = {
    Regular: 'regular',
    EmailGift: 'email_gift'
} as const;

export type ReferralRefEnum = typeof ReferralRefEnum[keyof typeof ReferralRefEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const RegisteredStatusEnum = {
    Registration: 'Registration',
    Account: 'Account',
    Property: 'Property'
} as const;

export type RegisteredStatusEnum = typeof RegisteredStatusEnum[keyof typeof RegisteredStatusEnum];


/**
 * 
 * @export
 * @interface ResponseMessage
 */
export interface ResponseMessage {
    /**
     * 
     * @type {string}
     * @memberof ResponseMessage
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface SalesAchievements
 */
export interface SalesAchievements {
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    'achievement_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    'achievement_area'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SalesAchievements
     */
    'achievement_price'?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    'file_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    'object_storage_path'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SalesNoteCompleteReasonEnum = {
    未完了: '未完了',
    ローンアウト: 'ローンアウト',
    他社購入: '他社購入',
    成約: '成約',
    その他: 'その他'
} as const;

export type SalesNoteCompleteReasonEnum = typeof SalesNoteCompleteReasonEnum[keyof typeof SalesNoteCompleteReasonEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SalesNoteProspectLankEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D'
} as const;

export type SalesNoteProspectLankEnum = typeof SalesNoteProspectLankEnum[keyof typeof SalesNoteProspectLankEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SalesNoteStatusEnum = {
    電話不通: '電話不通',
    日程調整中: '日程調整中',
    アポ取得済み: 'アポ取得済み',
    初回面談完了: '初回面談完了',
    申込完了: '申込完了',
    契約完了: '契約完了',
    ローン審査通過: 'ローン審査通過',
    決済完了: '決済完了',
    断念: '断念',
    短期追客: '短期追客',
    長期追客: '長期追客'
} as const;

export type SalesNoteStatusEnum = typeof SalesNoteStatusEnum[keyof typeof SalesNoteStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ScreenNameEnum = {
    Top: 'TOP',
    AgentDetail: 'AGENT_DETAIL'
} as const;

export type ScreenNameEnum = typeof ScreenNameEnum[keyof typeof ScreenNameEnum];


/**
 * 
 * @export
 * @interface UnitDetail
 */
export interface UnitDetail {
    /**
     * 
     * @type {string}
     * @memberof UnitDetail
     */
    'room_number'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDetail
     */
    'floor'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDetail
     */
    'occupied_area_m2'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDetail
     */
    'layout'?: UnitDetailLayoutEnum | null;
}

export const UnitDetailLayoutEnum = {
    未選択: '未選択',
    _1R: '1R',
    _1K: '1K',
    _1Lk1Ldk: '1LK/1LDK',
    _2L2Dk: '2L/2DK',
    _2Lk2Ldk: '2LK/2LDK',
    _3K3Dk: '3K/3DK',
    _3Lk3Ldk: '3LK/3LDK',
    _4K4Dk: '4K/4DK',
    _4Lk4Ldk: '4LK/4LDK',
    _5K5Dk: '5K/5DK',
    _5Lk5Ldk: '5LK/5LDK',
    _6K6Dk: '6K/6DK'
} as const;

export type UnitDetailLayoutEnum = typeof UnitDetailLayoutEnum[keyof typeof UnitDetailLayoutEnum];

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id'?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof User
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'family_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'family_name_kana'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_name_kana'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'is_enabled_email_notification'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'is_enabled_sms_notification'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'income_tax_rate'?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof User
     */
    'job_category'?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof User
     */
    'address_prefecture'?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof User
     */
    'job_industry'?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof User
     */
    'job_continuous_period'?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof User
     */
    'estimated_job_continuous_period'?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof User
     */
    'is_job_continuous_period_estimated'?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof User
     */
    'financial_asset'?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof User
     */
    'annual_income'?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof User
     */
    'holding_property_count'?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof User
     */
    'registered_holding_property_count'?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof User
     */
    'registered_considering_property_count'?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof User
     */
    'real_estate_loan_amount'?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof User
     */
    'current_residence_type_id'?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof User
     */
    'monthly_rent_payment_amount'?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof User
     */
    'home_loan_amount'?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof User
     */
    'consideration_period'?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof User
     */
    'past_meeting_count'?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof User
     */
    'considering_property'?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof User
     */
    'approved_financial_institutions'?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof User
     */
    'other_request_text'?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof User
     */
    'data_first_registered_status'?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof User
     */
    'request_the_proposal'?: boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof User
     */
    'way_to_propose'?: UserWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof User
     */
    'degree_of_consideration_for_investment'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof User
     */
    'degree_of_consideration_for_sale'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'purpose_of_use_free_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'inflow_route_free_text'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'email_confirmed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'last_seen_announcement_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'has_unread_announcements'?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof User
     */
    'is_diagnosis_complete'?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof User
     */
    'is_investment_style_diagnosis_complete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'password_confirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'withdrawal_intended_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'last_accessed_at'?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof User
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'account_updated_at'?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof User
     */
    'account_registered_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'first_match_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'read_offers_count'?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof User
     */
    'total_access_count'?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof User
     */
    'monthly_access_count'?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof User
     */
    'monthly_deduplication_access_count'?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof User
     */
    'matched_count_sum'?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    'matched_count_user'?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    'matched_count_investment'?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    'matched_count_assessment'?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    'matched_count_manual'?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof User
     */
    'learning_completed_count'?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof User
     */
    'learning_progress_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'adjust_network'?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof User
     */
    'adjust_tracker'?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof User
     */
    'referral_ref'?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof User
     */
    'account_register_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'phone_number_auth_code'?: number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof User
     */
    'assessment_proposals'?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof User
     */
    'investment_proposals'?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof User
     */
    'proposal_matchings'?: Array<ProposalMatching>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof User
     */
    'contract_applications'?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof User
     */
    'admin_user_memo'?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    'master_tags'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    'master_purpose_of_uses'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    'master_interested_property_types'?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof User
     */
    'interest_tag_ids'?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof User
     */
    'has_investment_experience'?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    'master_inflow_routes'?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof User
     */
    'current_residence_type'?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof User
     */
    'purpose_of_use_ids'?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof User
     */
    'interested_property_type_ids'?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof User
     */
    'inflow_route_ids'?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof User
     */
    'user_device_token'?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof User
     */
    'user_access_screen_log_monthly_summaries'?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof User
     */
    'age'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'is_new_label'?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof User
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'is_favorite'?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof User
     */
    'loan_amount'?: number | null;
}

export const UserWayToProposeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type UserWayToProposeEnum = typeof UserWayToProposeEnum[keyof typeof UserWayToProposeEnum];

/**
 * 
 * @export
 * @interface UserAccessScreenLogMonthlySummary
 */
export interface UserAccessScreenLogMonthlySummary {
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'user_id'?: number;
    /**
     * 
     * @type {ScreenNameEnum}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'screen_name'?: ScreenNameEnum;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'total_access_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'daily_deduplication_access_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    'updated_at'?: string;
}


/**
 * 
 * @export
 * @interface UserDataFirstRegisteredStatus
 */
export interface UserDataFirstRegisteredStatus {
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserDataFirstRegisteredStatus
     */
    'status'?: RegisteredStatusEnum;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserDataFirstRegisteredStatus
     */
    'referral_ref'?: ReferralRefEnum | null;
}


/**
 * 
 * @export
 * @interface UserDeviceToken
 */
export interface UserDeviceToken {
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'device_token': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    'user_id'?: number;
    /**
     * 
     * @type {DeviceTypeEnum}
     * @memberof UserDeviceToken
     */
    'device_type'?: DeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    'updated_at'?: string;
}


/**
 * ユーザーオファー発生元ソース
 * @export
 * @enum {string}
 */

export const UserOfferSourceAnalysisItemSourceEnum = {
    Top: 'top',
    AgentSearch: 'agent_search',
    SearchResult: 'search_result',
    TopViaDetail: 'top_via_detail',
    AgentSearchViaDetail: 'agent_search_via_detail',
    SearchResultViaDetail: 'search_result_via_detail',
    LimitedProperty: 'limited_property',
    LimitedPropertyViaDetail: 'limited_property_via_detail',
    LearningArticle: 'learning_article',
    LearningArticleViaDetail: 'learning_article_via_detail',
    SimilarAgentViaDetail: 'similar_agent_via_detail',
    DiagnosisCompatibilityAgentsViaDetail: 'diagnosis_compatibility_agents_via_detail',
    RegistrationCompatibilityAgents: 'registration_compatibility_agents',
    RegistrationCompatibilityAgentsViaDetail: 'registration_compatibility_agents_via_detail',
    DiagnosisCompatibilityAgents: 'diagnosis_compatibility_agents'
} as const;

export type UserOfferSourceAnalysisItemSourceEnum = typeof UserOfferSourceAnalysisItemSourceEnum[keyof typeof UserOfferSourceAnalysisItemSourceEnum];


/**
 * ユーザーオファーの経路カテゴリ
 * @export
 * @enum {string}
 */

export const UserOfferSourceCategoryEnum = {
    DirectBeforeSearch: 'direct_before_search',
    DirectAfterSearch: 'direct_after_search',
    AgentDetail: 'agent_detail'
} as const;

export type UserOfferSourceCategoryEnum = typeof UserOfferSourceCategoryEnum[keyof typeof UserOfferSourceCategoryEnum];


/**
 * 
 * @export
 * @interface UserProposal
 */
export interface UserProposal {
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    'agent_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    'proposal_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    'user_registered_at'?: string | null;
}
/**
 * 
 * @export
 * @interface UserRegistrations
 */
export interface UserRegistrations {
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    'id'?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof UserRegistrations
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'family_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'family_name_kana': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'first_name_kana': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_enabled_email_notification'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_enabled_sms_notification'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    'income_tax_rate'?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof UserRegistrations
     */
    'job_category'?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof UserRegistrations
     */
    'address_prefecture'?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof UserRegistrations
     */
    'job_industry'?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof UserRegistrations
     */
    'job_continuous_period'?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof UserRegistrations
     */
    'estimated_job_continuous_period'?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_job_continuous_period_estimated'?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof UserRegistrations
     */
    'financial_asset'?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof UserRegistrations
     */
    'annual_income'?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof UserRegistrations
     */
    'holding_property_count'?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserRegistrations
     */
    'registered_holding_property_count'?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserRegistrations
     */
    'registered_considering_property_count'?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof UserRegistrations
     */
    'real_estate_loan_amount'?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof UserRegistrations
     */
    'current_residence_type_id'?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof UserRegistrations
     */
    'monthly_rent_payment_amount'?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof UserRegistrations
     */
    'home_loan_amount'?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof UserRegistrations
     */
    'consideration_period'?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof UserRegistrations
     */
    'past_meeting_count'?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof UserRegistrations
     */
    'considering_property'?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof UserRegistrations
     */
    'approved_financial_institutions'?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof UserRegistrations
     */
    'other_request_text'?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserRegistrations
     */
    'data_first_registered_status'?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'request_the_proposal': boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof UserRegistrations
     */
    'way_to_propose'?: UserRegistrationsWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserRegistrations
     */
    'degree_of_consideration_for_investment'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserRegistrations
     */
    'degree_of_consideration_for_sale'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'purpose_of_use_free_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'inflow_route_free_text'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'email_confirmed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    'last_seen_announcement_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'has_unread_announcements'?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_diagnosis_complete'?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_investment_style_diagnosis_complete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'password_confirmation': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'withdrawal_intended_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'last_accessed_at'?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof UserRegistrations
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'account_updated_at'?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof UserRegistrations
     */
    'account_registered_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'first_match_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    'read_offers_count'?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof UserRegistrations
     */
    'total_access_count'?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof UserRegistrations
     */
    'monthly_access_count'?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof UserRegistrations
     */
    'monthly_deduplication_access_count'?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof UserRegistrations
     */
    'matched_count_sum'?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    'matched_count_user'?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    'matched_count_investment'?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    'matched_count_assessment'?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    'matched_count_manual'?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof UserRegistrations
     */
    'learning_completed_count'?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof UserRegistrations
     */
    'learning_progress_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    'adjust_network'?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof UserRegistrations
     */
    'adjust_tracker'?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserRegistrations
     */
    'referral_ref'?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof UserRegistrations
     */
    'account_register_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    'phone_number_auth_code': number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof UserRegistrations
     */
    'assessment_proposals'?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof UserRegistrations
     */
    'investment_proposals'?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof UserRegistrations
     */
    'proposal_matchings'?: Array<ProposalMatching>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof UserRegistrations
     */
    'contract_applications'?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof UserRegistrations
     */
    'admin_user_memo'?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    'master_tags'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    'master_purpose_of_uses'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    'master_interested_property_types'?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    'interest_tag_ids'?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'has_investment_experience'?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    'master_inflow_routes'?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof UserRegistrations
     */
    'current_residence_type'?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    'purpose_of_use_ids'?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    'interested_property_type_ids'?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    'inflow_route_ids'?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof UserRegistrations
     */
    'user_device_token'?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof UserRegistrations
     */
    'user_access_screen_log_monthly_summaries'?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof UserRegistrations
     */
    'age'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_new_label'?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    'is_favorite'?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof UserRegistrations
     */
    'loan_amount'?: number | null;
    /**
     * 登録元(LP識別子など)
     * @type {string}
     * @memberof UserRegistrations
     */
    'registration_source'?: string | null;
}

export const UserRegistrationsWayToProposeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type UserRegistrationsWayToProposeEnum = typeof UserRegistrationsWayToProposeEnum[keyof typeof UserRegistrationsWayToProposeEnum];

/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'id'?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof UserUpdate
     */
    'score'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'family_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'family_name_kana'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'first_name_kana'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_enabled_email_notification'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_enabled_sms_notification'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'birthday'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'income_tax_rate'?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof UserUpdate
     */
    'job_category'?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof UserUpdate
     */
    'address_prefecture'?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof UserUpdate
     */
    'job_industry'?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof UserUpdate
     */
    'job_continuous_period'?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof UserUpdate
     */
    'estimated_job_continuous_period'?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_job_continuous_period_estimated'?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof UserUpdate
     */
    'financial_asset'?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof UserUpdate
     */
    'annual_income'?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof UserUpdate
     */
    'holding_property_count'?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserUpdate
     */
    'registered_holding_property_count'?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserUpdate
     */
    'registered_considering_property_count'?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof UserUpdate
     */
    'real_estate_loan_amount'?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof UserUpdate
     */
    'current_residence_type_id'?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof UserUpdate
     */
    'monthly_rent_payment_amount'?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof UserUpdate
     */
    'home_loan_amount'?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof UserUpdate
     */
    'consideration_period'?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof UserUpdate
     */
    'past_meeting_count'?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof UserUpdate
     */
    'considering_property'?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof UserUpdate
     */
    'approved_financial_institutions'?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof UserUpdate
     */
    'other_request_text'?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserUpdate
     */
    'data_first_registered_status'?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'request_the_proposal'?: boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof UserUpdate
     */
    'way_to_propose'?: UserUpdateWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserUpdate
     */
    'degree_of_consideration_for_investment'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserUpdate
     */
    'degree_of_consideration_for_sale'?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'purpose_of_use_free_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'inflow_route_free_text'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'email_confirmed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'last_seen_announcement_id'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'has_unread_announcements'?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_diagnosis_complete'?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_investment_style_diagnosis_complete'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'password_confirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'withdrawal_intended_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'last_accessed_at'?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof UserUpdate
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'account_updated_at'?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof UserUpdate
     */
    'account_registered_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'discarded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'first_match_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'read_offers_count'?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof UserUpdate
     */
    'total_access_count'?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof UserUpdate
     */
    'monthly_access_count'?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof UserUpdate
     */
    'monthly_deduplication_access_count'?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof UserUpdate
     */
    'matched_count_sum'?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    'matched_count_user'?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    'matched_count_investment'?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    'matched_count_assessment'?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    'matched_count_manual'?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof UserUpdate
     */
    'learning_completed_count'?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof UserUpdate
     */
    'learning_progress_rate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'adjust_network'?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof UserUpdate
     */
    'adjust_tracker'?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserUpdate
     */
    'referral_ref'?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof UserUpdate
     */
    'account_register_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    'phone_number_auth_code'?: number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof UserUpdate
     */
    'assessment_proposals'?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof UserUpdate
     */
    'investment_proposals'?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof UserUpdate
     */
    'proposal_matchings'?: Array<ProposalMatching>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof UserUpdate
     */
    'contract_applications'?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof UserUpdate
     */
    'admin_user_memo'?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    'master_tags'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    'master_purpose_of_uses'?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    'master_interested_property_types'?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    'interest_tag_ids'?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof UserUpdate
     */
    'has_investment_experience'?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    'master_inflow_routes'?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof UserUpdate
     */
    'current_residence_type'?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    'purpose_of_use_ids'?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    'interested_property_type_ids'?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    'inflow_route_ids'?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof UserUpdate
     */
    'user_device_token'?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof UserUpdate
     */
    'user_access_screen_log_monthly_summaries'?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof UserUpdate
     */
    'age'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_new_label'?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    'is_favorite'?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof UserUpdate
     */
    'loan_amount'?: number | null;
}

export const UserUpdateWayToProposeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type UserUpdateWayToProposeEnum = typeof UserUpdateWayToProposeEnum[keyof typeof UserUpdateWayToProposeEnum];


/**
 * PropallyLpV1Api - axios parameter creator
 * @export
 */
export const PropallyLpV1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 精密査定フラグをtrueに更新
         * @param {number} assessmentId AI査定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1AiAssessmentsAssessmentIdPatch: async (assessmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('lpV1AiAssessmentsAssessmentIdPatch', 'assessmentId', assessmentId)
            const localVarPath = `/lp/v1/ai_assessments/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定実行
         * @param {AiAssessmentRequest} aiAssessmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1AiAssessmentsPost: async (aiAssessmentRequest: AiAssessmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiAssessmentRequest' is not null or undefined
            assertParamExists('lpV1AiAssessmentsPost', 'aiAssessmentRequest', aiAssessmentRequest)
            const localVarPath = `/lp/v1/ai_assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiAssessmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1HowmaBuildingsBuildingIdGet: async (buildingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            assertParamExists('lpV1HowmaBuildingsBuildingIdGet', 'buildingId', buildingId)
            const localVarPath = `/lp/v1/howma/buildings/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1HowmaBuildingsPost: async (howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'howMaBuildingsSearchRequest' is not null or undefined
            assertParamExists('lpV1HowmaBuildingsPost', 'howMaBuildingsSearchRequest', howMaBuildingsSearchRequest)
            const localVarPath = `/lp/v1/howma/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(howMaBuildingsSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lp/v1/master_data/prefectures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet: async (prefectureName: string, cityName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefectureName' is not null or undefined
            assertParamExists('lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet', 'prefectureName', prefectureName)
            // verify required parameter 'cityName' is not null or undefined
            assertParamExists('lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet', 'cityName', cityName)
            const localVarPath = `/lp/v1/master_data/prefectures/{prefecture_name}/cities/{city_name}/towns`
                .replace(`{${"prefecture_name"}}`, encodeURIComponent(String(prefectureName)))
                .replace(`{${"city_name"}}`, encodeURIComponent(String(cityName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesPrefectureNameCitiesGet: async (prefectureName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefectureName' is not null or undefined
            assertParamExists('lpV1MasterDataPrefecturesPrefectureNameCitiesGet', 'prefectureName', prefectureName)
            const localVarPath = `/lp/v1/master_data/prefectures/{prefecture_name}/cities`
                .replace(`{${"prefecture_name"}}`, encodeURIComponent(String(prefectureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataRailwaysGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lp/v1/master_data/railways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataRailwaysRailwayNameStationsGet: async (railwayName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'railwayName' is not null or undefined
            assertParamExists('lpV1MasterDataRailwaysRailwayNameStationsGet', 'railwayName', railwayName)
            const localVarPath = `/lp/v1/master_data/railways/{railway_name}/stations`
                .replace(`{${"railway_name"}}`, encodeURIComponent(String(railwayName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary LP会員登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1RegistrationsPost: async (userRegistrations: UserRegistrations, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegistrations' is not null or undefined
            assertParamExists('lpV1RegistrationsPost', 'userRegistrations', userRegistrations)
            const localVarPath = `/lp/v1/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegistrations, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {LpV1SendPhoneNumberAuthCodesPostRequest} lpV1SendPhoneNumberAuthCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1SendPhoneNumberAuthCodesPost: async (lpV1SendPhoneNumberAuthCodesPostRequest: LpV1SendPhoneNumberAuthCodesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lpV1SendPhoneNumberAuthCodesPostRequest' is not null or undefined
            assertParamExists('lpV1SendPhoneNumberAuthCodesPost', 'lpV1SendPhoneNumberAuthCodesPostRequest', lpV1SendPhoneNumberAuthCodesPostRequest)
            const localVarPath = `/lp/v1/send_phone_number_auth_codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lpV1SendPhoneNumberAuthCodesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary データ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1UserDataFirstRegisteredStatusPatch: async (userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDataFirstRegisteredStatus' is not null or undefined
            assertParamExists('lpV1UserDataFirstRegisteredStatusPatch', 'userDataFirstRegisteredStatus', userDataFirstRegisteredStatus)
            const localVarPath = `/lp/v1/user/data_first_registered_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDataFirstRegisteredStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1UserPatch: async (userUpdate: UserUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdate' is not null or undefined
            assertParamExists('lpV1UserPatch', 'userUpdate', userUpdate)
            const localVarPath = `/lp/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropallyLpV1Api - functional programming interface
 * @export
 */
export const PropallyLpV1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PropallyLpV1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 精密査定フラグをtrueに更新
         * @param {number} assessmentId AI査定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1AiAssessmentsAssessmentIdPatch(assessmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1AiAssessmentsAssessmentIdPatch(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1AiAssessmentsAssessmentIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 査定実行
         * @param {AiAssessmentRequest} aiAssessmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1AiAssessmentsPost(aiAssessmentRequest: AiAssessmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiAssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1AiAssessmentsPost(aiAssessmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1AiAssessmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1HowmaBuildingsBuildingIdGet(buildingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HowMaRoomsSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1HowmaBuildingsBuildingIdGet(buildingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1HowmaBuildingsBuildingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HowMaBuildingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1HowmaBuildingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1MasterDataPrefecturesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1MasterDataPrefecturesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1MasterDataPrefecturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1MasterDataPrefecturesPrefectureNameCitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1MasterDataRailwaysGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1MasterDataRailwaysGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1MasterDataRailwaysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1MasterDataRailwaysRailwayNameStationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary LP会員登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1RegistrationsPost(userRegistrations: UserRegistrations, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1RegistrationsPost(userRegistrations, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1RegistrationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {LpV1SendPhoneNumberAuthCodesPostRequest} lpV1SendPhoneNumberAuthCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest: LpV1SendPhoneNumberAuthCodesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LpV1SendPhoneNumberAuthCodesPost201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1SendPhoneNumberAuthCodesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary データ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataFirstRegisteredStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1UserDataFirstRegisteredStatusPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lpV1UserPatch(userUpdate: UserUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lpV1UserPatch(userUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PropallyLpV1Api.lpV1UserPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PropallyLpV1Api - factory interface
 * @export
 */
export const PropallyLpV1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PropallyLpV1ApiFp(configuration)
    return {
        /**
         * 
         * @summary 精密査定フラグをtrueに更新
         * @param {number} assessmentId AI査定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1AiAssessmentsAssessmentIdPatch(assessmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.lpV1AiAssessmentsAssessmentIdPatch(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定実行
         * @param {AiAssessmentRequest} aiAssessmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1AiAssessmentsPost(aiAssessmentRequest: AiAssessmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiAssessmentResponse> {
            return localVarFp.lpV1AiAssessmentsPost(aiAssessmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1HowmaBuildingsBuildingIdGet(buildingId: number, options?: RawAxiosRequestConfig): AxiosPromise<HowMaRoomsSearchResponse> {
            return localVarFp.lpV1HowmaBuildingsBuildingIdGet(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<HowMaBuildingsResponse> {
            return localVarFp.lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.lpV1MasterDataPrefecturesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataRailwaysGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<IdName>> {
            return localVarFp.lpV1MasterDataRailwaysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary LP会員登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1RegistrationsPost(userRegistrations: UserRegistrations, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.lpV1RegistrationsPost(userRegistrations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {LpV1SendPhoneNumberAuthCodesPostRequest} lpV1SendPhoneNumberAuthCodesPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest: LpV1SendPhoneNumberAuthCodesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LpV1SendPhoneNumberAuthCodesPost201Response> {
            return localVarFp.lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary データ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: RawAxiosRequestConfig): AxiosPromise<UserDataFirstRegisteredStatus> {
            return localVarFp.lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lpV1UserPatch(userUpdate: UserUpdate, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.lpV1UserPatch(userUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropallyLpV1Api - object-oriented interface
 * @export
 * @class PropallyLpV1Api
 * @extends {BaseAPI}
 */
export class PropallyLpV1Api extends BaseAPI {
    /**
     * 
     * @summary 精密査定フラグをtrueに更新
     * @param {number} assessmentId AI査定 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1AiAssessmentsAssessmentIdPatch(assessmentId: number, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1AiAssessmentsAssessmentIdPatch(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定実行
     * @param {AiAssessmentRequest} aiAssessmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1AiAssessmentsPost(aiAssessmentRequest: AiAssessmentRequest, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1AiAssessmentsPost(aiAssessmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
     * @param {number} buildingId (HowMa管理の)マンションID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1HowmaBuildingsBuildingIdGet(buildingId: number, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1HowmaBuildingsBuildingIdGet(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary HowMa(外部API)物件検索API
     * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1HowmaBuildingsPost(howMaBuildingsSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 都道府県一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1MasterDataPrefecturesGet(options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1MasterDataPrefecturesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 町丁目一覧
     * @param {string} prefectureName 都道府県名
     * @param {string} cityName 市区町村名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 市区町村一覧
     * @param {string} prefectureName 都道府県名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 鉄道一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1MasterDataRailwaysGet(options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1MasterDataRailwaysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 駅名一覧
     * @param {string} railwayName 鉄道名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1MasterDataRailwaysRailwayNameStationsGet(railwayName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary LP会員登録
     * @param {UserRegistrations} userRegistrations 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1RegistrationsPost(userRegistrations: UserRegistrations, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1RegistrationsPost(userRegistrations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 電話番号認証コード送信
     * @param {LpV1SendPhoneNumberAuthCodesPostRequest} lpV1SendPhoneNumberAuthCodesPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest: LpV1SendPhoneNumberAuthCodesPostRequest, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1SendPhoneNumberAuthCodesPost(lpV1SendPhoneNumberAuthCodesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary データ初回登録ステータス更新
     * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー情報更新
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyLpV1Api
     */
    public lpV1UserPatch(userUpdate: UserUpdate, options?: RawAxiosRequestConfig) {
        return PropallyLpV1ApiFp(this.configuration).lpV1UserPatch(userUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



